import { Popover } from "antd";
import { DisableType, useFeatureFlag } from "../../Hooks/useFeatureFlag";

const RenderContent = ({ message }) => (
    <div>
        <p className="mb-0">{message}</p>
    </div>
);

export const FeatureFlag = ({ name, children }) => {
    const features = useFeatureFlag();

    if (features[name] && features[name].disabled) {
        const flag = features[name];
        if (flag.disableType === DisableType.hidden) return null;

        return (
            <Popover content={<RenderContent message={flag.message} />} placement="bottom">
                <div style={{ opacity: 0.4 }}>{children}</div>
            </Popover>
        );
    }

    return children;
};
